import React from 'react';

interface InfoRowProps {
  label: string;
  value: string;
  highlight?: boolean;
}

export default function InfoRow({ label, value, highlight }: InfoRowProps) {
  return (
    <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
      <span style={{ width: 100, flexShrink: 0, fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>{label}</span>
      <span style={{
        fontSize: 'var(--text-sm)',
        color: highlight ? 'var(--color-primary)' : 'var(--color-text)',
        fontWeight: highlight ? 600 : 400,
      }}>
        {value}
      </span>
    </div>
  );
}
